"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const StarIcon_1 = require("../../../icons/StarIcon");
const TickIcon_1 = require("../../../icons/TickIcon");
const constants_1 = require("../constants");
/**
 * Badge component that renders different types of badge icons
 */
function Badge({ badge }) {
    switch (badge) {
        case constants_1.BADGE.STAR:
            return (0, jsx_runtime_1.jsx)(StarIcon_1.StarIcon, { size: "MEDIUM" });
        case constants_1.BADGE.TICK:
            return (0, jsx_runtime_1.jsx)(TickIcon_1.TickIcon, { size: "MEDIUM" });
        default:
            return null;
    }
}
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map